import axios from "@/plugins/axios";

export default {
    getCustomerTags(creditorId) {
        let params = {}
        if (creditorId) params.creditor_id = creditorId

        return axios.httpApi.get(`customer_tags`, { params });
    },
};
